var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialising = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Party-Beer-Cheers--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Party Beer Cheers Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 1.5h-0.5A0.25 0.25 0 0 1 5 1.25v-0.5a0.75 0.75 0 0 0 -1.5 0v0.5a0.25 0.25 0 0 1 -0.25 0.25h-0.5a0.75 0.75 0 0 0 0 1.5h0.5a0.25 0.25 0 0 1 0.25 0.25v0.5a0.75 0.75 0 0 0 1.5 0v-0.5A0.25 0.25 0 0 1 5.25 3h0.5a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 6.5h-0.5a0.25 0.25 0 0 1 -0.25 -0.25v-0.5a0.75 0.75 0 0 0 -1.5 0v0.5a0.25 0.25 0 0 1 -0.25 0.25h-0.5a0.75 0.75 0 0 0 0 1.5h0.5a0.25 0.25 0 0 1 0.25 0.25v0.5a0.75 0.75 0 0 0 1.5 0v-0.5a0.25 0.25 0 0 1 0.25 -0.25h0.5a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.38a3.39 3.39 0 0 1 0.64 -0.06h2.87a0.5 0.5 0 0 0 0.49 -0.44 2.13 2.13 0 0 1 1.6 -2 0.51 0.51 0 0 0 0.38 -0.49V8.93a1.59 1.59 0 0 0 -1 -1.52c-0.47 -0.26 -0.85 -0.47 -0.85 -1.57V2.12A1.12 1.12 0 0 0 11 1h-0.6a1.12 1.12 0 0 0 -1.12 1.12v3.72c0 1.11 -0.38 1.32 -0.86 1.6a1.58 1.58 0 0 0 -1 1.49v4a0.48 0.48 0 0 0 0.18 0.38 0.47 0.47 0 0 0 0.4 0.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 1 0 -2.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.25a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13.5a0.5 0.5 0 0 0 -0.5 -0.5h-4a0.5 0.5 0 0 0 -0.5 0.5v0.29a0.51 0.51 0 0 1 -0.22 0.42 0.52 0.52 0 0 1 -0.47 0 2.12 2.12 0 0 1 -0.8 -0.53 4 4 0 0 0 -3.28 -1.64 1 1 0 0 0 -1 1v1a0.5 0.5 0 0 1 -0.5 0.5H8.66a2.22 2.22 0 0 0 -1.81 0.93 2.19 2.19 0 0 0 -0.31 2l1.65 5A2.24 2.24 0 0 0 10.31 24h3.78a4.59 4.59 0 0 0 1.8 -0.36l2.44 -0.86a0.5 0.5 0 0 1 0.46 0.07 0.49 0.49 0 0 1 0.21 0.41v0.24a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.5 -0.5Zm-8.89 1.55a0.48 0.48 0 0 1 0.37 -0.3 0.44 0.44 0 0 1 0.43 0.18 4.57 4.57 0 0 0 2.69 1.49 0.5 0.5 0 0 1 0.4 0.49v3.17a0.5 0.5 0 0 1 -0.33 0.47l-3.51 1.23a2.63 2.63 0 0 1 -1.07 0.22h-3.78a0.24 0.24 0 0 1 -0.22 -0.16l-1.66 -5a0.23 0.23 0 0 1 0 -0.21 0.21 0.21 0 0 1 0.19 -0.1H13a2.24 2.24 0 0 0 2.11 -1.48Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialising);
export default ForwardRef;